import { render, staticRenderFns } from "./Unidades.vue?vue&type=template&id=33b44f10&scoped=true&lang=pug&"
import script from "./Unidades.vue?vue&type=script&lang=js&"
export * from "./Unidades.vue?vue&type=script&lang=js&"
import style0 from "./Unidades.styl?vue&type=style&index=0&id=33b44f10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b44f10",
  null
  
)

export default component.exports